var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, TemplateRef, OnDestroy } from '@angular/core';
import { LayerService } from './../../../services/layer.service';
import { CommonTableService } from './../../../services/common-table.service';
import { ToastrService } from 'ngx-toastr';
import { CommonDatagridComponent } from './../../common-datagrid/common-datagrid.component';
import { UserService } from 'app/services/user.service';
import { CommonFunctionService } from 'app/services/common-function.service';
var UserAdminDataComponent = /** @class */ (function () {
    function UserAdminDataComponent(commonService, layerService, tableService, userService, toastr) {
        this.commonService = commonService;
        this.layerService = layerService;
        this.tableService = tableService;
        this.userService = userService;
        this.toastr = toastr;
        // rows of selected layer type
        this.layerHistories = [];
        this.deleteColumn = 'gly_deleted';
        this.selectedColumn = 'selected';
        this.buildTopoColumn = 'is_topo_built';
        this.layerTypeId = null;
        // array of each input true/false value
        // public selects: { selected: boolean }[] = [];
        // selected rows' array
        this.historySelected = [];
    }
    UserAdminDataComponent.prototype.setTable = function () {
        var _this = this;
        var columns = this.tableService.setColumnsFromRows(this.layerHistories);
        columns.forEach(function (c) {
            if (c.prop === 'state') {
                c.cellClass = 'cell-align-C';
            }
            else if (c.prop === _this.deleteColumn || c.prop === _this.selectedColumn || c.prop === _this.buildTopoColumn) {
                _this.tableService.hideColumn(c);
            }
        });
        if (columns.length) {
            columns.unshift({
                isDisplay: true,
                name: ' ',
                prop: 'selected',
                type: 'text',
                width: 30,
                cellTemplate: this.checkbox,
                headerTemplate: this.headerTempl,
                cellClass: 'cell-align-C',
                info: { fixedCellClass: [] }
            }, { isDisplay: true,
                name: 'DELETE STATE',
                prop: 'deleteStatus',
                type: 'text',
                width: 100,
                cellTemplate: this.deleteStatus,
                cellClass: 'cell-align-C',
                info: { fixedCellClass: [] }
            });
        }
        this.columns = columns;
    };
    UserAdminDataComponent.prototype.getLayerHistory = function () {
        return __awaiter(this, void 0, void 0, function () {
            var rsp, rows_1, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.commonService.setLoadingSpinner(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.cleanData();
                        return [4 /*yield*/, this.layerService.getRawLayers(this.userService.getCustomerIdByType(), this.layerTypeId, true)];
                    case 2:
                        rsp = _a.sent();
                        rows_1 = [];
                        rsp.data.forEach(function (d) {
                            if (d.gly_id) {
                                // this.layerHistories.push(d);
                                d.selected = false;
                                rows_1.push(d);
                            }
                        });
                        this.layerHistories = rows_1;
                        this.setTable();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.commonService.setLoadingSpinner(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    // clean data
    UserAdminDataComponent.prototype.cleanData = function () {
        this.historySelected = [];
        this.isDelete = null;
        this.isPurge = null;
    };
    // control single checkbox
    UserAdminDataComponent.prototype.toggleCheckBox = function (event, row) {
        if (event.target.checked) {
            this.historySelected.push(row);
        }
        else { // uncheck the checkbox
            var index = this.historySelected.indexOf(row);
            this.historySelected.splice(index, 1);
        }
        this.setDeletable();
        this.setPurgeable();
    };
    UserAdminDataComponent.prototype.selectAll = function (event) {
        if (event.target.checked) {
            this.layerHistories.forEach(function (row) {
                row.selected = true;
            });
            // push all layerHistories in historySelected array
            this.historySelected = this.layerHistories;
        }
        else {
            this.layerHistories.forEach(function (row) {
                row.selected = false;
            });
            this.historySelected = [];
        }
        this.setDeletable();
        this.setPurgeable();
    };
    // disable delete button
    UserAdminDataComponent.prototype.setDeletable = function () {
        var _this = this;
        if (this.historySelected.some(function (e) { return e[_this.deleteColumn] === false; })) {
            this.isDelete = true;
        }
        else {
            this.isDelete = false;
        }
    };
    // disable purge button
    UserAdminDataComponent.prototype.setPurgeable = function () {
        var _this = this;
        if (this.historySelected.some(function (e) { return e[_this.deleteColumn] === true; })) {
            this.isPurge = true;
        }
        else {
            this.isPurge = false;
        }
    };
    UserAdminDataComponent.prototype.deleteLayers = function () {
        var _this = this;
        var promises = [];
        this.historySelected.forEach(function (d) {
            if (d[_this.deleteColumn] === false) {
                promises.push(new Promise(function (resolve, reject) {
                    _this.layerService.deleteLayer(d.gly_id, resolve, reject);
                }));
            }
        });
        Promise.all(promises).then(function (rsp) {
            _this.getLayerHistory();
            _this.toastr.success('Successfully Deleted !');
        })
            .catch(function (e) {
            _this.toastr.error('Delete Failed');
        });
    };
    UserAdminDataComponent.prototype.purgeLayer = function () {
        var _this = this;
        var promises = [];
        this.historySelected.forEach(function (d) {
            if (d[_this.deleteColumn] === true) {
                promises.push(new Promise(function (resolve, reject) {
                    _this.layerService.purgeLayer(d.gly_id, resolve, reject);
                }));
            }
        });
        Promise.all(promises).then(function (rsp) {
            _this.getLayerHistory();
            _this.toastr.success('Successfully Purged !');
        })
            .catch(function (e) {
            _this.toastr.error('Purge Failed');
        });
    };
    UserAdminDataComponent.prototype.onChangeCustomer = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLayerHistory()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserAdminDataComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var rsp, err_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.pageSize = 50;
                        this.isAdmin = this.userService.getUserInfo().isAdmin;
                        this.customerType = this.userService.customerInfo.type;
                        this.selectedCustomerSub = this.userService.selectedCustomer.subscribe(function (data) {
                            if (data) {
                                var selectedCustomerId = data.id;
                                _this.onChangeCustomer({
                                    id: selectedCustomerId
                                });
                            }
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.layerService.getRawLayers(this.userService.getCustomerIdByType())];
                    case 2:
                        rsp = _a.sent();
                        this.layers = rsp.data;
                        return [4 /*yield*/, this.getLayerHistory()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_2 = _a.sent();
                        console.log(err_2);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    UserAdminDataComponent.prototype.ngOnDestroy = function () {
        this.selectedCustomerSub.unsubscribe();
    };
    return UserAdminDataComponent;
}());
export { UserAdminDataComponent };
